<template lang="pug">
#myAgency(v-loading="loading" element-loading-text="数据加载中")
  .title 我的抄送
  .content
    .header-midd
      search(ref="approveSearch"  @change="handleSearch")
    .midd
      el-table(ref="multipleTable"  highlight-current-row size="small" border height="100%"
        :data="tableData")
        el-table-column(type="index" label="编号" align="center" width="60")
        el-table-column(label="状态" sortable prop="status" width="80px" align="center" v-slot="{row}")
          span.flowStatus(:class="`type${row.status}`") {{statusName(row.status)}}
        el-table-column(label="流程类型" sortable align="center" prop="flowType" min-width="80px")
        el-table-column(label="标题" sortable prop="title" min-width="120px" v-slot="{row}")
          el-link(type="primary" @click="cellClick(row)" v-if='(row.status === 2)||(row.status !== 9 && row.status !== 2)')
            span(class="tabLinkSpan" :title='row.title') {{ row.title }}
          span(v-else class="tabLinkSpan" :title='row.title') {{ row.title }}
        el-table-column(label="内容" prop="content" min-width="100px" show-overflow-tooltip)
        el-table-column(label="申请人" prop="flowInstanceOwnerName" min-width="100px")
        el-table-column(label="开始时间" prop="flowInstanceStartTime" min-width="100px" show-overflow-tooltip)
        el-table-column(label="当前审批人" align="center" prop="currentNodeAssigneeName" min-width="200px" show-overflow-tooltip)
        el-table-column(label="上个审批节点" align="center" prop="lastNodeName" min-width="200px" show-overflow-tooltip)
        el-table-column(label="操作" align="center" v-slot="{row}")
          el-button(type="text" v-if="row.status === 2" @click.stop="clickChange(row, 'edit')") 审批
          el-button(type="text" v-if="row.status !== 9 && row.status !== 2" @click.stop="clickChange(row, 'view')") 查看
          //- el-button(type="text" @click.stop="clickChange(row)") 查看
    .page
      el-pagination(:current-page.sync="page.pageNum"
        :page-size="page.pageSize"
        :layout="page.pageLayout"
        :total="page.totalCount"
        v-if="page.totalCount > 0"
        :page-sizes="[10, 20, 50, 100]"
        size="small"
        background
        @size-change="handleSizeChange"
        @current-change="handleCurrentChange")
</template>

<script>
import search from "@/CommonDP/pages/mainMg/approval/config/search.vue";
import flowService from "@/CommonDP/service/flow-service";
import approvalService from "@/CommonDP/service/approve-service";
import { mapState } from "vuex";
import { getStatusName } from "@/CommonDP/components/processComponents/config";
import { openFlow } from "@/CommonDP/components/processComponents/flowNew/index.js";

export default {
  name: "MyCopysend",
  components: { search },
  data () {
    return {
      tableData: [],
      loading: false,
      page: {
        pageLayout: "total, sizes, prev, pager, next, jumper",
        pageNum: 1,
        pageSize: 20,
        totalCount: 0
      },
      comment: "", // 审批意见
      flowInstanceNodeId: '',
      viewMode: 2, // 新增0 审批1 查看2
      statusName: getStatusName
    };
  },
  computed: {
    searchFormParams() {
      return this.$refs.approveSearch.getForm();
    },
    ...mapState({
      enterpriseId: (state) => state.enterprise.enterpriseId
    })
  },
  mounted () {
    this.page.pageNum = 1;
    this.getPendList();
  },
  methods: {
    handleSearch(form) {
      this.page.pageNum = 1;
      this.getPendList();
    },
    async getPendList() {
      const { page: { pageNum, pageSize }} = this;
      this.loading = true;
      const { data, pageIndex, totalCount } = await flowService.cc(this.searchFormParams, pageNum, pageSize);
      this.tableData = data;
      this.page.pageNum = pageIndex;
      this.loading = false;
      this.page.totalCount = totalCount;
    },
    updateTable() {
      this.getPendList();
    },
    handleSizeChange(val) {
      this.page.pageSize = val;
      this.getPendList();
    },
    handleCurrentChange(val) {
      this.page.pageNum = val;
      this.getPendList();
    },
    async clickChange(row, approveType) {
      const { currentVersionId = "", flowInstanceId = "", flowKey, businessId = "", startMode } = row;
      const data = { currentVersionId, flowInstanceId, flowKey, approveType, businessId, enterpriseId: this.enterpriseId, isProject: this.isProject };
      // 新窗口打开
      if (startMode === "stdNew") {
        const routeUrl = this.$router.resolve({ path: "/examine-new", query: data });
        window.open(routeUrl.href, "_blank");
      } else {
        await openFlow(data);
        this.getPendList();
      }
    },
    withdraw(row) {
      this.$confirm(`您确定撤回当前流程吗?`, "警告", { type: "warning" }).then(async () => {
        await flowService.withdraw({ flowInstanceId: row.flowInstanceId });
        this.$success("流程撤回成功");
        this.getPendList();
      }).catch(() => {
        // this.$message.info("已取消删除");
      });
    },

    handleSizeTaskChange(val) {
      this.page.pageSize = val;
      this.getTaskList();
    },
    handleCurrentTaskChange(val) {
      this.page.pageNum = val;
      this.getTaskList();
    },
    // 任务项目
    async getTaskPrjList() {
      const res = await approvalService.queryTaskPrjList(this.enterpriseId);
      this.taskPrjListList = res.data;
    },
    async getTaskList() {
      this.loading = true;
      const { data, pageIndex, totalCount } = await approvalService.queryMySubmitListTask(this.taskformParams);
      this.taskData = data;
      this.loading = false;
      this.page.pageNum = pageIndex;
      this.page.totalCount = totalCount;
    },
    // 我的任务查询
    searchChange() {
      this.page.pageNum = 1;
      this.getTaskList();
    },
    // 重置
    resetForm() {
      this.taskform.prjId = "";
      this.taskform.taskName = "";
      this.page.pageNum = 1;
      this.getTaskList();
    },
    cellClick(row) {
      const type = row.status === 2 ? 'edit' : 'view' ;
      this.clickChange(row, type);
    }
  }
};
</script>

<style lang="scss" scoped>
#myAgency {
  width: 100%;
  height: 100%;
  overflow: hidden;
  padding: 0 var(--big-space);
  display: flex;
  flex-direction: column;
  .content {
    height: 1px;
    flex-grow: 1;
    display: flex;
    flex-direction: column;
  }
}

.title {
  height: 40px;
  line-height: 40px;
  font-size: 16px;
  color: var(--key-color);
  font-weight: 700;
  border-bottom: 2px solid #E4E7ED;
  margin-top: var(--small-space);
  margin-bottom: var(--middle-space);
}

.midd {
  flex: 1 1;
  overflow: hidden;
}

.page {
  margin: var(--middle-space) 0;
  display: flex;
  flex-direction: row;
  justify-content: flex-end;
}

.flowStatus {
  border-radius: 6px;
  text-align: center;
  padding: 2px 8px;
}
.type1,.type4{
  border: 1px solid #10A667;
  background: rgba(16, 166, 103, 0.10);
  color: #10A667;
}

.type2 {
  border: 1px solid #FF7A00;
  background: rgba(255, 122, 0, 0.10);
  color: #FF7A00;
}

.type3 {
  border: 1px solid #60656B;
  background: rgba(96, 101, 107, 0.10);
  color: #60656B;
}

.type8 {
  border: 1px solid #9746E8;
  background: rgba(151, 70, 232, 0.10);
  color: #9746E8;
}

.type9 {
  border: 1px solid #2F8BF8;
  background: rgba(47, 139, 248, 0.10);
  color: #2F8BF8
}

.type0 {
  border: 1px solid #FF4A4A;
  background: rgba(255, 74, 74, 0.10);
  color: #FF4A4A;
}
</style>
